import { BannerSegmentEnum } from 'generated/graphql';

/**
 * The banners a profile's hero shows: every one but the About tab's, which the
 * About tab shows on its own. A profile whose only banner is its About one
 * keeps it, so the hero is never left without a picture.
 */
export const professionalHeroBanners = <
    T extends { bannerSegment?: BannerSegmentEnum | null },
>(
    banners: readonly T[],
): T[] => {
    const hero = banners.filter(
        (banner) => banner.bannerSegment !== BannerSegmentEnum.Aboutus,
    );
    return hero.length ? hero : [...banners];
};
